import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';
import { track } from 'utils/tracking';

import Facebook from 'components/shareIcons/facebook';
import Instagram from 'components/shareIcons/instagram';
import Tiktok from 'components/shareIcons/tiktok';
import Twitter from 'components/shareIcons/twitter';
import Youtube from 'components/shareIcons/youtube';
import LinkedIn from 'components/shareIcons/linkedIn';

import s from 'components/shareIcons/shareIcons.sss';

export default class ShareIcons extends Component {
	constructor(props) {
		super(props);

		this.linkIcons = {
			facebook: <Facebook height="32" />,
			instagram: <Instagram height="32" />,
			tiktok: <Tiktok height="32" />,
			twitter: <Twitter height="32" />,
			youtube: <Youtube height="32" />,
			linkedin: <LinkedIn height="32" />,
		};

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		if (this.props.tracking) {
			track('social', this.props.tracking, e.currentTarget.dataset.name);
		}
	}

	renderLink(link) {
		return (
			<a
				href={link.destination}
				target="_blank"
				rel="noopener noreferrer"
				title={`Focus Features on ${link.name}`}
				onClick={this.onClick}
				data-name={link.name}
			>
				{this.linkIcons[link.id]}
			</a>
		);
	}

	render(props) {
		return <div class={joinClasses(s.wrapper, props.class)}>{props.links?.map((link) => this.renderLink(link))}</div>;
	}
}
